/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PayloadPersonPatch,
  Response,
  PersonaStructure,
  getPersonResponse,
  PepsStructure,
  getPepsResponse,
  PayloadRequestAvalAditional,
  PostPersonResponse,
  PayloadPersonPepsPost,
  PatchPersonResponse,
} from "src/types";
import { baseApi } from "./baseApi";

const personasApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPersons: build.query<
      PersonaStructure[],
      { loanApplicationId: string; personTypeId?: string; personTypeCode?: string[]; id?: string }
    >({
      query: ({ loanApplicationId, personTypeId, personTypeCode, id }) => {
        let url = `personas?size=100&q=loan_application_id:${loanApplicationId}`;
        if (id) url += `&q=id:${id}`;
        if (personTypeId) url += `&q=person_type_id:${personTypeId}`;
        if (personTypeCode?.length) {
          personTypeCode.forEach((item) => {
            url += `&q_person_type_code=${item}`;
          });
        }
        return {
          url,
        };
      },
      transformResponse: (response: getPersonResponse) => {
        return response.data.data;
      },
    }),
    getPersonById: build.query<PersonaStructure, string>({
      query: (personId) => `personas/${personId}`,
      transformResponse: (response: any) => {
        return response.data;
      },
    }),
    patchPerson: build.mutation<PatchPersonResponse, { personId: string; body: PayloadPersonPatch }>({
      query: ({ personId, body }) => ({
        url: `personas/${personId}`,
        method: "PATCH",
        body: body,
      }),
    }),
    postPerson: build.mutation<PostPersonResponse, { body: PayloadPersonPatch }>({
      query: ({ body }) => ({
        url: `personas`,
        method: "POST",
        body: body,
      }),
    }),
    getPersonPeps: build.query<PepsStructure[], { personId: string }>({
      query: ({ personId }) => `personas/${personId}/peps`,
      transformResponse: (response: getPepsResponse) => {
        return response?.data || [];
      },
    }),
    postPersonPeps: build.mutation<Response, { personId: string; body: PayloadPersonPepsPost }>({
      query: ({ personId, body }) => ({
        url: `personas/${personId}/peps`,
        method: "POST",
        body,
      }),
    }),
    postPersonAvalAditional: build.mutation<Response, { body: PayloadRequestAvalAditional }>({
      query: ({ body }) => ({
        url: `personas/aval_adicional`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetPersonsQuery,
  useLazyGetPersonByIdQuery,
  usePatchPersonMutation,
  usePostPersonMutation,
  useLazyGetPersonPepsQuery,
  usePostPersonPepsMutation,
  usePostPersonAvalAditionalMutation,
} = personasApi;
